<template>
  <div id="memberinfo">
    <Banner title="會員專區" :breadcrumbs="breadcrumbs" type="member"></Banner>
    <div class="container">
      <div class="center_title">
        <Title en="Member Profile" chtFirst="會員" chtSecond="資料" :center="true"></Title>
      </div>
      <section class="content">
        <div class="remark" v-if="!IsUpdated">
          <p>您的帳號已驗證成功!</p>
          <p>請您填寫以下入會申請書後，並完成下列步驟，</p>
          <p>以利完成入會申請，謝謝。</p>
        </div>
        <div class="global_title">修改會員資料</div>
        <div class="box">
          <div class="output">
            <div class="input_span">
              <span>中文姓名*</span>
              <input
                type="text"
                placeholder="請填寫中文姓名"
                v-model="MemberInfo.Name"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              />
            </div>
            <div class="input_span">
              <span>英文姓名*</span>
              <input
                type="text"
                placeholder="請填寫英文姓名"
                v-model="MemberInfo.EngName"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              />
            </div>
            <div class="input_span">
              <span>身分證字號*</span>
              <input
                type="text"
                placeholder="請填寫您的身分證字號"
                v-model="MemberInfo.Identification"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              />
            </div>
            <div class="input_span">
              <span>性別*</span>
              <select
                name="sex"
                v-model="MemberInfo.Gender"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              >
                <option value="null" selected disabled>請選擇您的性別</option>
                <option value="0">男</option>
                <option value="1">女</option>
              </select>
            </div>
            <div class="input_span">
              <span>出生年月日*</span>
              <input
                type="date"
                v-model="MemberInfo.Birthday"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              />
            </div>
            <div class="input_span">
              <span>通訊地址</span>
              <div class="select">
                <select name="City" v-model="selectCity" required>
                  <option value="null" selected disabled>請選擇縣市</option>
                  <option v-for="(city,index) in CityArea" :value="city">{{city}}</option>
                </select>
                <select name="District" required v-model="selectDistrict">
                  <option value="null" selected disabled>請選擇鄉鎮市區</option>
                  <option v-for="(district,index) in DistrictArea" :value="district">{{district}}</option>
                </select>
                <input type="text" placeholder="請填寫完整地址" v-model="MemberInfo.Address" />
              </div>
            </div>
            <div class="input_span">
              <span>聯絡信箱</span>
              <input type="text" placeholder="請填寫您的E-mail" v-model="MemberInfo.ContactBox" />
            </div>
            <div class="input_span">
              <span>聯絡電話</span>
              <input type="text" placeholder="請填寫您的聯絡電話" v-model="MemberInfo.Mobile" />
            </div>
            <div class="input_span">
              <span>住院醫師-訓練醫院*</span>
              <div class="introduction">
                <input
                  type="date"
                  v-model="MemberInfo.ResidentTrainStartOn"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
                <div>※訓練起始日</div>
                <input
                  type="date"
                  v-model="MemberInfo.ResidentTrainEndOn"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
                <div>※訓練結束日</div>
              </div>
            </div>
            <div class="input_span">
              <span>視網膜專科訓練醫院*</span>
              <div class="introduction">
                <input
                  type="date"
                  v-model="MemberInfo.RetinaTrainStartOn"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
                <div>※訓練起始日</div>
                <input
                  type="date"
                  v-model="MemberInfo.RetinaTrainEndOn"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
                <div>※訓練結束日</div>
              </div>
            </div>
            <div class="input_span">
              <span>目前服務單位</span>
              <textarea placeholder="請填寫您的目前服務單位" v-model="MemberInfo.Affiliation"></textarea>
            </div>
            <div class="input_span">
              <span>現任職務</span>
              <textarea placeholder="請填寫您的現任職務" v-model="MemberInfo.Position"></textarea>
            </div>
            <div class="input_span">
              <span>畢業學校*</span>
              <!-- <input
                type="text"
                placeholder="請填寫您的畢業學校"
                v-model="MemberInfo.Education"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              /> -->
              <textarea 
                placeholder="請填寫您的畢業學校"
                v-model="MemberInfo.Education"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              >
              </textarea>
            </div>
            <div class="input_span">
              <span>畢業證書字號*</span>
              <input
                type="text"
                placeholder="請填寫您的畢業證書字號"
                v-model="MemberInfo.Diploma"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              />
            </div>
            <div class="input_span">
              <span>醫師證書字號*</span>
              <input
                type="text"
                placeholder="請填寫您的醫師證書字號"
                v-model="MemberInfo.Certification"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              />
            </div>
            <div class="input_span">
              <span>專科醫師證號*</span>
              <input
                type="text"
                placeholder="請填寫您的專科醫師證號"
                v-model="MemberInfo.SpecialistNumber"
                :disabled="IsUpdated"
                :class="{'updated':IsUpdated}"
              />
            </div>
            <div class="input_span">
              <span>第一介紹人*</span>
              <div class="introduction">
                <input
                  type="text"
                  placeholder="請填寫介紹人大名"
                  v-model="MemberInfo.Introducer"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
                <input
                  type="text"
                  placeholder="請填寫介紹人E-mail"
                  v-model="MemberInfo.IntroducerEmail"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
                <div>※必須為主要視網膜專科訓練的老師，並請附上E-mail</div>
              </div>
            </div>
            <div class="input_span">
              <span>第二介紹人*</span>
              <div class="introduction">
                <input
                  type="text"
                  placeholder="請填寫介紹人大名"
                  v-model="MemberInfo.SecondIntroducer"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
                <input
                  type="text"
                  placeholder="請填寫介紹人E-mail"
                  v-model="MemberInfo.SecondIntroducerEmail"
                  :disabled="IsUpdated"
                  :class="{'updated':IsUpdated}"
                />
              </div>
            </div>
          </div>
          <div class="final" v-if="!IsUpdated">
            <p>以上填寫完成之後，請準備下方資料:</p>

            <p>一、請點擊 "儲存並列印"按鈕，將資料列印出，並請本學會二位會員介紹人簽名。</p>
            <p>二、醫學院校畢業證書一份。</p>
            <p>三、醫師證書及專科醫師證書一份。</p>

            <p>完成後至中華民國視網膜學會 "會員專區" 的 <a href="/Member/Status">"年會費繳納"</a> 頁面，上傳資料，以利入會審核，謝謝。</p>
          </div>
          <div class="btn_box">
            <div class="item">
              <div class="White_btn islogin" @click="reset">
                <a href="javascript:;">重新填寫</a>
              </div>
            </div>
            <div class="item">
              <div class="Orange_btn islogin">
                <a v-if="IsUpdated" href="javascript:;" @click="update">修改</a>
                <a v-if="!IsUpdated" href="javascript:;" v-print="'#output'" @click="update">儲存並列印</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <graybtn />
    </div>
    <div class="output_popup" v-show="false">
      <div class="popup_content">
        <div id="output">
            <div class="title">中華民國視網膜醫學會會員入會申請書</div>
            <table class='output_table' cellspacing="3">
                <tr>
                    <td colspan="26%">姓名</td>
                    <td colspan="37%">(中文){{MemberInfo.Name}}</td>
                    <td colspan="37%">(英文){{MemberInfo.EngName}}</td>
                </tr>
                <tr>
                    <td colspan="26%">身分證字號</td>
                    <td colspan="74%">{{MemberInfo.Identification}}</td>
                </tr>
                <tr>
                    <td colspan="26%">出生年月日</td>
                    <td colspan="74%">{{$moment(MemberInfo.Birthday).format("LL")}}</td>
                </tr>
                <tr>
                    <td colspan="26%">通訊地址</td>
                    <td colspan="74%">{{MemberInfo.City + MemberInfo.District + MemberInfo.Address}}</td>
                </tr>
                <tr>
                    <td colspan="26%">E-mail</td>
                    <td colspan="24%">{{MemberInfo.ContactBox}}</td>
                    <td colspan="26%">電話</td>
                    <td colspan="24%">{{MemberInfo.Mobile}}</td>
                </tr>
                 <tr>
                    <td colspan="26%">畢業學校</td>
                    <td colspan="24%">{{MemberInfo.Education}}</td>
                    <td colspan="26%">畢業證書字號</td>
                    <td colspan="24%">{{MemberInfo.Diploma}}</td>
                </tr>
                <tr>
                    <td colspan="26%">醫師證書字號</td>
                    <td colspan="24%">{{MemberInfo.Certification}}</td>
                    <td colspan="26%">專科醫師證號</td>
                    <td colspan="24%">{{MemberInfo.SpecialistNumber}}</td>
                </tr>
                <tr>
                    <td colspan="26%">住院醫師-訓練 醫院自__年__月起至__年__止</td>
                    <td colspan="24%">{{$moment(MemberInfo.ResidentTrainStartOn).format("LL") + "起至" +  $moment(MemberInfo.ResidentTrainEndOn).format("LL")}}</td>
                    <td colspan="26%">視網膜專科訓練醫院自__年__月起至__年__止</td>
                    <td colspan="24%">{{$moment(MemberInfo.RetinaTrainStartOn).format("LL") + "起至" +  $moment(MemberInfo.RetinaTrainEndOn).format("LL")}}</td>
                </tr>
                <tr>
                    <td colspan="26%">目前服務單位</td>
                    <td colspan="24%">{{MemberInfo.Affiliation}}</td>
                    <td colspan="26%">現任職務</td>
                    <td colspan="24%">{{MemberInfo.Position}}</td>
                </tr>
                <tr>
                    <td colspan="26%" rowspan="3">介紹人<br><span class="remark">※第一位介紹人必須為主要視網膜專科訓練的老師，並請附上email。</span></td>
                    <td colspan="37%">1.{{MemberInfo.Introducer}}</td>
                    <td colspan="37%">2.{{MemberInfo.SecondIntroducer}}</td>
                </tr>
                <tr>
                    <td colspan="37%">Email:{{MemberInfo.IntroducerEmail}}</td>
                    <td colspan="37%">Email:{{ MemberInfo.SecondIntroducerEmail}}</td>
                </tr>
                <tr>
                    <td colspan="37%">簽名:</td>
                    <td colspan="37%">簽名:</td>
                </tr>
                <tr>
                    <td colspan="100%">□同時申請加入中華民國眼部炎症醫學會</td>
                </tr>
                <tr>
                    <td colspan="100%">
                        <p>中華民國視網膜醫學會申請入會辦法:</p>
                        <p>一、	申請入會申請書一份</p>
                        <p>二、	醫學院校畢業證書影本一份</p>
                        <p>三、	醫師證書及專科醫師證書影本各一份</p>
                        <p>四、	申請新入會醫師必須將證件繳齊，由本學會二位會員擔任介紹人並簽名，申請書經理監事審核通過後成為正式會員</p>
                        <p>五、	審核通過後，將再通知匯款繳交入會費5000元，當年會費1000元，共計6000元。</p>
                        <p>六、	備妥資料後請上傳至學會官網：http://www.retina.org.tw/<br>
                            Tel:0965-106-869
                        </p>
                    </td>
                </tr>
            </table>
        </div>
        <div class="btn_box">
            <div class="item">
                <div class="White_btn islogin" @click="closePrint">
                    <a href="javascript:;">關閉彈窗</a>
                </div>
            </div>
            <div class="item">
                <div class="Orange_btn islogin">
                    <a href="javascript:;" v-print="'#output'">列印</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/common";
import API from "@/service/member";
export default {
  name: "memberinfo",
  components: {},
  props: {
    api: {
      type: Object
    },
    auditstatus: {
      type: String
    }
  },
  data() {
    return {
      breadcrumbs: [
        {
          url: "/",
          title: "首頁"
        },
        {
          title: "會員專區"
        },
        {
          url: "/memberInfo",
          title: "會員資料"
        }
      ],
      CityArea: [],
      DistrictArea: [],
      selectCity: "null",
      selectDistrict: "null",
      IsUpdated: false,
      IsNeddOpenPrint:false,
      MemberInfo: {
        Id: "", //GID
        Email: "", //帳號
        Name: "", //中文姓名
        EngName: "", //英文姓名
        Birthday:"", //出生年月日
        Identification: "", //身分證
        Affiliation: "", //服務單位
        Position: "", //職稱
        Education: "", //畢業學校
        Diploma: "", //畢業證書字號
        Certification: "", //醫生證書字號
        SpecialistNumber: "", //專科醫師字號
        ContactBox: "", //Email
        Gender: "null", //性別
        Telephone: "", //電話
        Mobile: "", //手機
        Country: "", //國家
        Province: "", //省
        City: "", //城市
        District: "null", //地區
        ZipCode: "", //區碼
        Address: "", //詳細地址
        Introducer: "", //推薦人
        IntroducerEmail: "", //推薦人
        SecondIntroducer: "", //推薦人
        SecondIntroducerEmail: "", //推薦人
        ResidentTrainStartOn:"", //訓練起始時間
        ResidentTrainEndOn:"",//訓練結束時間
        RetinaTrainStartOn:"",//訓練起始時間
        RetinaTrainEndOn:"",//訓練結束時間
      }
    };
  },
  methods: {
    update() {
      const vm = this;
      let params;
      if (vm.IsUpdated) {
        params = {
          Id: vm.MemberInfo.Id,
          Email: vm.MemberInfo.Email,
          City: vm.MemberInfo.City,
          District: vm.MemberInfo.District,
          Address: vm.MemberInfo.Address,
          ContactBox: vm.MemberInfo.ContactBox,
          Mobile: vm.MemberInfo.Mobile,
          Affiliation: vm.MemberInfo.Affiliation,
          Position: vm.MemberInfo.Position
        };
      } else {
        params = vm.MemberInfo;
        vm.IsNeddOpenPrint = true;
      }
      API.getUpdateProfile(params).then(res => {
        if (res.Ok) {
          vm.$swal({
            type: "success",
            text: "會員資料更新成功!",
            confirmButtonText: "確定"
          }).then(() => {
            // location.href = "/Member/Status";
          });
        } else {
          vm.$swal({
            type: "fail",
            text: "會員資料更新失敗，請稍後在試或連繫系統工程師!",
            confirmButtonText: "確定"
          });
        }
      });
    },
    reset() {
      const vm = this;
      if (vm.IsUpdated) {
        vm.$set(vm.MemberInfo, "City", "");
        vm.$set(vm.MemberInfo, "District", "");
        vm.$set(vm.MemberInfo, "Address", "");
        vm.$set(vm.MemberInfo, "ContactBox", "");
        vm.$set(vm.MemberInfo, "Mobile", "");
        vm.$set(vm.MemberInfo, "Affiliation", "");
        vm.$set(vm.MemberInfo, "Position", "");
      } else {
        vm.$set(vm.MemberInfo, "Name", "");
        vm.$set(vm.MemberInfo, "EngName", "");
        vm.$set(vm.MemberInfo, "Identification", "");
        vm.$set(vm.MemberInfo, "Education", "");
        vm.$set(vm.MemberInfo, "Diploma", "");
        vm.$set(vm.MemberInfo, "Certification", "");
        vm.$set(vm.MemberInfo, "SpecialistNumber", "");
        vm.$set(vm.MemberInfo, "Gender", null);
        vm.$set(vm.MemberInfo, "Birthday", "");
        vm.$set(vm.MemberInfo, "City", null);
        vm.$set(vm.MemberInfo, "District", null);
        vm.$set(vm.MemberInfo, "Address", "");
        vm.$set(vm.MemberInfo, "ContactBox", "");
        vm.$set(vm.MemberInfo, "Mobile", "");
        vm.$set(vm.MemberInfo, "Affiliation", "");
        vm.$set(vm.MemberInfo, "Position", "");
        vm.$set(vm.MemberInfo, "Introducer", "");
        vm.$set(vm.MemberInfo, "IntroducerEmail", "");
        vm.$set(vm.MemberInfo, "SecondIntroducer", "");
        vm.$set(vm.MemberInfo, "SecondIntroducerEmail", "");
        vm.$set(vm.MemberInfo, "ResidentTrainStartOn", "");
        vm.$set(vm.MemberInfo, "ResidentTrainEndOn", "");
        vm.$set(vm.MemberInfo, "RetinaTrainStartOn", "");
        vm.$set(vm.MemberInfo, "RetinaTrainEndOn", "");
      }
    },
    closePrint(){
      const vm = this;
      vm.IsNeddOpenPrint = false;
    }
  },
  computed: {},
  created() {
    const vm = this;
    vm.CityArea = Common.Area();
    // console.log(vm.api);
    if (vm.api) {
      vm.MemberInfo = vm.api;
      vm.$set(vm.MemberInfo, "Birthday",  vm.$moment(vm.api.Birthday).format("YYYY-MM-DD"));
      vm.$set(vm.MemberInfo, "ResidentTrainStartOn",  vm.$moment(vm.api.ResidentTrainStartOn).format("YYYY-MM-DD"));
      vm.$set(vm.MemberInfo, "ResidentTrainEndOn",  vm.$moment(vm.api.ResidentTrainEndOn).format("YYYY-MM-DD"));
      vm.$set(vm.MemberInfo, "RetinaTrainStartOn",  vm.$moment(vm.api.RetinaTrainStartOn).format("YYYY-MM-DD"));
      vm.$set(vm.MemberInfo, "RetinaTrainEndOn",  vm.$moment(vm.api.RetinaTrainEndOn).format("YYYY-MM-DD"));
      if (vm.auditstatus != "Success") {
        vm.IsUpdated = false;
      } else {
        vm.IsUpdated = true;
      }

      if (vm.api.City) {
        (async function() {
          vm.selectCity = await vm.api.City;
          // console.log(vm.selectCity);
          vm.DistrictArea = await Common.Area(vm.selectCity);
          // console.log(vm.DistrictArea);
          vm.selectDistrict = await vm.api.District;
          vm.$set(vm.MemberInfo, "District", vm.selectDistrict);
        })();
      }
    }
  },
  mounted() {},
  watch: {
    selectCity: {
      // immediate: false,
      handler(newValue, oldValue) {
        // console.log(newValue);
        const vm = this;
        // console.log(oldValue);
        vm.$set(vm.MemberInfo, "City", newValue);
        if (oldValue == null || oldValue == "null") {
          vm.DistrictArea = Common.Area(newValue);
        } else {
          vm.DistrictArea = Common.Area(newValue);
          vm.selectDistrict = null;
          vm.$set(vm.MemberInfo, "District", null);
        }
      }
    },
    selectDistrict: {
      handler(value) {
        const vm = this;
        if (value == null || value == "null") {
        } else {
          vm.$set(vm.MemberInfo, "District", value);
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
#memberinfo .content {
  border: 8px solid #eee;
  padding: 20px;
  color: #666;
}
#memberinfo .content .box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}
#memberinfo .content .box .output {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}
#memberinfo .content .select,
#memberinfo .content .introduction {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: calc(100% - 167px);
}
#memberinfo .content .introduction input {
  width: 100%;
  margin-bottom: 5px;
}
#memberinfo .content .introduction > div {
  color: #f00;
  letter-spacing: 1px;
  line-height: 1.2;
  font-size: 0.7rem;
  margin-bottom: 15px;
}
#memberinfo .content .select select {
  width: 49%;
  margin-bottom: 10px;
}
#memberinfo .content .select select + select {
  margin-left: 2%;
}
#memberinfo .content .select input {
  width: 100%;
}
#memberinfo .content .btn_box {
  margin: auto;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  /* width: 350px; */
  padding: 30px 0;
}
#memberinfo .content .btn_box .item {
  width: 48%;
}
#memberinfo .content .remark {
  text-align: center;
  line-height: 1.5;
  letter-spacing: 2px;
  margin-bottom: 20px;
}
#memberinfo .content .final {
  line-height: 1.5;
  letter-spacing: 2px;
  padding: 30px 0;
}

#memberinfo .output_popup {
    position: fixed;
    top: 0;
    z-index: 999;
    left: 0;
    right: 0;
    margin: auto;
    background-color: rgba(0,0,0,.5);
    width: 100vw;
    height: 100%;
    padding-top: 60px;
    overflow-y:scroll; 
}
.popup_content {
    background:#fff;
    max-width: 800px;
    margin:auto;
    padding: 20px 30px;
    
}
#output .title {
    font-size: 1.5rem;
    margin:auto;
    padding: 20px;
    text-align: center;
}

#output table.output_table {
    color:#333333;
    border-width: 1px;
    border-color: #ccc;
    border-collapse: collapse;
    width: 100%;
    font-size: 0.9rem;
    table-layout:fixed
}
#output table.output_table td {
  border-width: 1px;
  padding: 15px 10px;
  border-style: solid;
  border-color: #ccc;
  background-color: #ffffff;
  line-height: 1.5;
}
#output table.output_table td p {
    text-indent :-33px;
    padding-left: 33px;
}

#output table.output_table tr td.table_title{
    width: 25%;
}
#output table.output_table tr td .remark {
    color:#666;
    padding-top: 10px;
    font-size: 0.9rem;
}
.popup_content .btn_box {
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-top: 30px;
}
.popup_content .btn_box .item{
    width: 48%;
}
@media screen and (max-width: 767px) {
  #memberinfo .content {
    padding: 20px 10px;
  }
  #memberinfo .content .select,
  #memberinfo .content .introduction {
    width: 100%;
  }
  #memberinfo .content .btn_box {
    width: 100%;
    justify-content: space-between;
  }
  .popup_content {
      width: 98%;
      margin:auto;
      padding: 15px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/memberInfo.vue